import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuctionTransportFeeModalService {

  private selectedAuctionTransportFeeSubject = new BehaviorSubject<any>(null);
  public selectedAuctionTransportFee$ = this.selectedAuctionTransportFeeSubject.asObservable();

  constructor() { }

  setSelectedAuctionTransportFee(auctionTransportFee: any): void {
    this.selectedAuctionTransportFeeSubject.next(auctionTransportFee);
  }

  clearSelectedAuctionTransportFee(): void {
    this.selectedAuctionTransportFeeSubject.next(null);
  }

  getSelectedAuctionTransportFee(): any {
    return this.selectedAuctionTransportFeeSubject.value;
  }
}
